type PurchaseAccessLike = {
  aiAccess?: AccessLevelLike;
  allLevelStudyAccess?: AccessLevelLike;
  hasSubscriptionToManage?: boolean;
  studyAccess?: AccessLevelLike;
};

type AccessLevelLike = {
  active?: boolean;
  source?: string;
};

type PurchasedProductLike = {
  humanReadable?: string;
  priceId?: string;
  sku?: string;
  source?: string;
  type?: string;
};

export function shouldShowManagePayments({
  purchaseAccess,
  purchasedProducts,
}: {
  purchaseAccess?: PurchaseAccessLike;
  purchasedProducts?: PurchasedProductLike[];
}): boolean {
  if (purchaseAccess?.hasSubscriptionToManage) {
    return true;
  }

  // The forced-access source differs by producer: the shared client-side
  // helper (forcePurchaseAccessToPurchaseAccess) emits "FORCE_PURCHASE_ACCESS",
  // while the backend /check-purchase-state endpoint tags the same override
  // "PROFILE: forcePurchaseAccess". Accept both so forced users are treated as
  // having a manageable subscription regardless of which path computed access.
  const FORCED_ACCESS_SOURCES = [
    "FORCE_PURCHASE_ACCESS",
    "PROFILE: forcePurchaseAccess",
  ];
  const hasForcedPaidAccess = [
    purchaseAccess?.studyAccess,
    purchaseAccess?.allLevelStudyAccess,
    purchaseAccess?.aiAccess,
  ].some(
    (access) =>
      access?.active === true &&
      FORCED_ACCESS_SOURCES.includes(access.source ?? "")
  );

  if (hasForcedPaidAccess) {
    return true;
  }

  return Boolean(
    purchasedProducts?.some(
      (product) =>
        product.source === "stripe" ||
        product.type === "subscription" ||
        Boolean(product.priceId) ||
        Boolean(product.sku) ||
        Boolean(product.humanReadable)
    )
  );
}
